module.exports = __webpack_public_path__ + "static/media/livechat.a04138e8.svg";